<template>
  <div class="p-5">
    <div class="text-center p-4">
      <MobiusLogo to="/home" />
    </div>
    <div v-if="loading" class="m-auto mt-4 p-4 text-center">
      <IconifyIcon :icon="icons.bxTimeFive" height="32" />
      <h2 class="h4 mt-4">Validando...</h2>
    </div>
    <div
      v-if="isValid && !loading"
      class="m-auto mt-4 p-4 text-center"
      style="max-width: 500px"
    >
      <IconifyIcon :icon="icons.bxCheckCircle" height="32" />
      <h2 class="h4 mt-4">Gracias por registrarte</h2>
      <p v-if="loginSuccess" class="text-muted">Cuenta verificada. Redirigiendo…</p>
      <button v-else class="btn btn-primary" @click="goToLogin()">
        Iniciar sesión
      </button>
    </div>
    <div
      v-if="!isValid && !loading"
      class="m-auto mt-4 p-4 text-center"
      style="max-width: 500px"
    >
      <IconifyIcon :icon="icons.bxUnlink" height="32" />
      <h2 class="h4 mt-4">
        El enlace de verificación es inválido o ha vencido, intenta registrarte
        nuevamente.
      </h2>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import IconifyIcon from "@iconify/vue";
import bxCheckCircle from "@iconify/icons-bx/bx-check-circle";
import bxUnlink from "@iconify/icons-bx/bx-unlink";
import bxTimeFive from "@iconify/icons-bx/bx-time-five";
import { getApiUrl } from "@/Utils/api-url-helper";
import { getUserData } from "@/services/auth.service.js";
import { loadRegistrationIntent } from "@/views/V2/olimpiadas/registrationFlow";
import MobiusLogo from "@/components/MobiusLogo.vue";

export default {
  name: "VarifyEmail",
  props: ["verificationKey"],
  components: {
    IconifyIcon,
    MobiusLogo,
  },
  data() {
    return {
      isValid: false,
      loginSuccess: false,
      icons: {
        bxCheckCircle,
        bxUnlink,
        bxTimeFive,
      },
      loading: true,
    };
  },
  methods: {
    getRedirectTarget() {
      const queryRedirect = this.$route.query.redirect;
      const querySource = this.$route.query.source;

      if (queryRedirect === "/olimpiadas" || queryRedirect === "/olimpiadas/profile") {
        return "/olimpiadas";
      }
      if (querySource === "olimpiadas") {
        return "/olimpiadas";
      }

      const intent = loadRegistrationIntent();
      if (intent) {
        return "/olimpiadas";
      }

      return "/login";
    },
    goToLogin() {
      const target = this.getRedirectTarget();
      if (target === "/olimpiadas") {
        this.$router.push({
          path: "/v2/auth/login",
          query: { redirect: "/olimpiadas" },
        });
      } else {
        this.$router.push(target);
      }
    },
    validateToken() {
      const token = this.$route.params.token;
      if (!token) {
        this.loading = false;
        this.isValid = false;
        this.$toasted.error("Enlace de verificación incompleto.", {
          position: "top-center",
          duration: 3000,
        });
        return;
      }
      const apiBaseUrl = getApiUrl(import.meta.env.VITE_API_BASE_URL);
      let loader = this.$loading.show({});
      axios
        .get(`${apiBaseUrl}/auth/verify-email/${token}`)
        .then(async (response) => {
          const accessToken = response.data.accessToken;
          if (!accessToken) {
            this.loading = false;
            this.isValid = true;
            loader.hide();
            return;
          }
          try {
            const userResponse = await getUserData(accessToken);
            this.$store.dispatch("auth/setLogin", {
              ...userResponse.data,
              token: accessToken,
            });
            this.loginSuccess = true;
            this.$router.push(this.getRedirectTarget());
          } catch (e) {
            console.error("Verify email: failed to load user", e);
            this.$toasted.info(
              "Cuenta verificada. Inicia sesión para continuar.",
              { position: "top-center", duration: 4000 }
            );
            this.isValid = true;
          }
          this.loading = false;
          loader.hide();
        })
        .catch((error) => {
          console.error("Verify email error:", error);
          this.loading = false;
          this.isValid = false;
          loader.hide();
          this.$toasted.error(
            "El enlace de verificación es inválido o ha vencido. Intenta registrarte nuevamente.",
            { position: "top-center", duration: 5000 }
          );
        });
    },
  },
  mounted() {
    this.validateToken();
  },
};
</script>
